// extracted by mini-css-extract-plugin
export default {"appSubtitle":"Title_appSubtitle__T5udp"};